import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'select-mobile-dialog',
  templateUrl: './select-mobile-dialog.component.html',
  styleUrls: ['./select-mobile-dialog.component.scss']
})
export class SelectMobileDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ){ }

  displayFieldName: string;
  valueFieldName: string;
  items: Array<any> = [];
  form: UntypedFormGroup;

  ngOnInit(): void {
    this.displayFieldName = this.data.displayFieldName;
    this.valueFieldName = this.data.valueFieldName;
    this.items = this.data.records;
    this.form =  this.data.form;
  }
}
